"use client";

import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { ChevronsUpDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { getAvailableDashboards } from "@/lib/rbac";
import type { UserInfo } from "@/types/api";

export function DashboardSwitcher() {
  const router = useRouter();
  const { data: session } = useSession();
  const user = session?.user as UserInfo | undefined;

  if (!user) return null;

  const dashboards = getAvailableDashboards(user);

  if (dashboards.length <= 1) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1 text-xs">
          Switch Dashboard
          <ChevronsUpDown className="size-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {dashboards.map((dashboard) => (
          <DropdownMenuItem
            key={dashboard.key}
            onClick={() => router.push(dashboard.path)}
          >
            {dashboard.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
